/**
 * Elige qué campo de imagen cruda usar en una card de listado: `square`
 * (`image_square`) si viene con contenido, si no `vertical` (`image_vertical`)
 * — nunca la panorámica (`image_panoramic`, fuera de alcance por ahora).
 * Reutilizado por los mappers de `/data`, `/search` y `/postsales`
 * (`mapProductToCard`, `mapSearchItemToCard`, `mapPostsaleToCard`): los tres
 * sustituyeron su antiguo campo `image` único por este trío de campos. Cada
 * mapper aplica después su propia sanitización/validación (dedupe de
 * protocolo, sentinel de "imagen no disponible"…) al resultado — de ahí que
 * SIEMPRE devuelva un `string` (nunca `null`/`undefined`), aunque ninguno de
 * los dos campos venga aprovechable: `image_vertical` está tipado como
 * `string` obligatorio, pero el backend real lo ha mandado `null`/ausente
 * (visto en listados reales) — sin el `?? ''` final, ese valor se colaba tal
 * cual hasta `sanitizeImageUrl`/`resolveImage`, que esperan un `string` y
 * lanzan al llamar a `.replace`/`.trim()` sobre `null`.
 */
export function resolveCardImage(square: string | null | undefined, vertical: string | null | undefined): string {
  return square || vertical || ''
}
